import cx from 'classnames';
import styles from './styles.scss';
import { node } from 'prop-types';

export const ActivityStyles = ({ children }) => {
  return <section className={cx(styles.activityStyles)}>{children}</section>;
};

ActivityStyles.propTypes = {
  children: node.isRequired,
};
// extracting styles so they can be used in InputStory
